import { render } from "./NoDataAspect.vue?vue&type=template&id=8055f084&scoped=true"
import script from "./NoDataAspect.vue?vue&type=script&lang=js"
export * from "./NoDataAspect.vue?vue&type=script&lang=js"

import "./NoDataAspect.vue?vue&type=style&index=0&id=8055f084&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8055f084"]])

export default __exports__